import React, { useRef, useState } from "react";
import { AiOutlineAlignLeft } from "react-icons/ai";
import { AiOutlineAlignCenter } from "react-icons/ai";
import { AiFillCaretDown } from "react-icons/ai";
import { AiFillCaretUp } from "react-icons/ai";
import { AiOutlineAlignRight } from "react-icons/ai";
import { Divider } from "antd";
import { RiText } from "react-icons/ri";
import { BiText } from "react-icons/bi";
import { RiBold } from "react-icons/ri";
import { MdGradient } from "react-icons/md";
import { BsFillImageFill } from "react-icons/bs";
import { RiItalic } from "react-icons/ri";
import { CgFormatLineHeight } from "react-icons/cg";
import { GrMultiple } from "react-icons/gr";
import { MdOpacity } from "react-icons/md";
import { RiPencilFill } from "react-icons/ri";
import { RiBringToFront } from "react-icons/ri";
import { RiSendToBack } from "react-icons/ri";
import { ImUndo, ImRedo } from "react-icons/im";
import { FaPaintRoller } from "react-icons/fa";
import { IoColorFill } from "react-icons/io5";
import { AiFillHighlight } from "react-icons/ai";
import { FaEraser } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { SketchPicker } from "react-color";
import "fabric-history";
import {
  notification,
  Dropdown,
  InputNumber,
  Menu,
  Modal,
  Select,
  Tooltip,
  Radio,
  Slider,
} from "antd";
import {
  setOpenColorPicker,
  setOpenBgColorPicker,
  setOpacityBoxOpen,
  setSpaceBoxOpen,
  setPencilBoxOpen,
  setStrokeBoxOpen,
  setShadowBoxOpen,
  setGradientBoxOpen,
  setCustomGradientBoxOpen,
  setLineColorBoxOpen,
  setShadowColorBoxOpen,
  setCustom2GradientBoxOpen,
  setIsDrawingMode,
} from "./../../slices/creatorSlice";
import {
  handleFontChange,
  handleFontSizeChange,
  handleFontStyleChange,
  handleFontBgColor,
  sliddervaluechange,
  sliddervaluechange2,
  addImage,
  deleteObject,
  addText,
  changePageBgColorOnChangeComplete,
  handleStrokeStyleChange,
  changePageBgColorOnChange,
  pageBgImage,
  handleFontColor,
  handleStrokeColor,
  clearCanvas,
  objectBringForward,
  objectSendBackward,
  changeOpacity,
  alignLeft,
  alignCenter,
  alignRight,
  addStroke,
  xAxisChange,
  yAxisChange,
  blurChange,
  handleShadowColor,
  handleCustomGradientBoxColor,
  handleCustom2GradientBoxColor,
  handleGradientPallete,
  lineWidthChange,
  shadowWidthChange,
  shadowOffsetChange,
  handleLineColorChange,
  handleShadowColorChange,
  handleModeChange,
} from "../../CommonFunctions/PropertybarFunctions";

import { copySelectedToAll } from "../../slices/creatorSlice";
import { useDispatch, useSelector } from "react-redux";
import PalleteColor from "../../CommonFunctions/jsonData/gradientColorPalletes.json";
import FontList from "../../CommonFunctions/jsonData/fontList.json";
// Top right notification popup
const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: message,
    description: "",
  });
};

const PropertyBar = ({ canvas }) => {
  // // Fill color
  // const [openColorPicker, setOpenColorPicker] = useState(false)
  // // Font background color
  // const [openBgColorPicker, setOpenBgColorPicker] = useState(false)
  // // Line space popup box
  //const [spaceBoxOpen, setSpaceBoxOpen] = useState(false)

  const openOpacityBox = useSelector((state) => state.creator.openOpacityBox);
  const gradientBoxOpen = useSelector((state) => state.creator.gradientBoxOpen);
  const customGradientBoxOpen = useSelector(
    (state) => state.creator.customGradientBoxOpen
  );
  const lineColorBoxOpen = useSelector(
    (state) => state.creator.lineColorBoxOpen
  );
  const shadowColorBoxOpen = useSelector(
    (state) => state.creator.shadowColorBoxOpen
  );
  const custom2GradientBoxOpen = useSelector(
    (state) => state.creator.custom2GradientBoxOpen
  );
  const openBgColorPicker = useSelector(
    (state) => state.creator.openBgColorPicker
  );
  const openColorPicker = useSelector((state) => state.creator.openColorPicker);
  const pencilBoxOpen = useSelector((state) => state.creator.pencilBoxOpen);
  const spaceBoxOpen = useSelector((state) => state.creator.spaceBoxOpen);
  const strokeBoxOpen = useSelector((state) => state.creator.strokeBoxOpen);
  const shadowBoxOpen = useSelector((state) => state.creator.shadowBoxOpen);
  // const isDrawingMode = useSelector((state) => state.creator.isDrawingMode);
  const [pageColor, setPageColor] = useState("#ffffff");
  const [opacityValue, setOpacityValue] = useState(1);
  const [inputValue, setInputValue] = useState(1.16);
  const [linewidthValue, setLinewidthValue] = useState(2);
  const [shadowWidthValue, setShadowWidthValue] = useState(0);
  const [shadowOffsetValue, setShadowOffsetValue] = useState(0);

  const [inputValue2, setInputValue2] = useState(0);
  const [xAxis, setXAxis] = useState(0);
  const [yAxis, setYAxis] = useState(0);
  const [blur, setBlur] = useState(0);
  const [currentShadowColor, setCurrentShadowColor] = useState("#000000");

  const [currentFont, setCurrentFont] = useState("Merriweather");
  const [currentFontSize, setCurrentFontSize] = useState(40);
  const [currentFontStyle, setCurrentFontStyle] = useState(0);
  const [currentFontColor, setCurrentFontColor] = useState("#000000");
  const [currentFontBgColor, setCurrentFontBgColor] = useState("transparent");
  const [isDropDownVisible, setIsDropDownVisible] = useState(false);
  const [clearCanvasModel, setClearCanvasModel] = useState(false);
  const [currentStrokeColor, setCurrentStrokeColor] = useState("#ffffff");
  const [defaultMode, setDefaultMode] = useState("--select mode--");
  const [customGradientBoxColor, setCustomGradientBoxColor] = useState(
    "#ffffff"
  );
  const [lineColor, setLineColor] = useState("#000000");
  const [shadowColor, setShadowColor] = useState("#000000");
  const [custom2GradientBoxColor, setCustom2GradientBoxColor] = useState(
    "#ffffff"
  );
  // const [currentFontLineHeight, setFontLineHeight] = useState(1.16);
  const imgUploadRef = useRef(null);
  const bgImgUploadRef = useRef(null);
  const dispatch = useDispatch();
  const isBgColorPickerOpen = true;
  const fonts = FontList.sort();

  const { Option } = Select;

  const handleImgUploadBtnClick = () => {
    imgUploadRef.current.click();
  };
  const handleBgImgUploadBtnClick = () => {
    bgImgUploadRef.current.click();
  };
  const copyToAllPages = () => {
    if (canvas.getActiveObject()) {
      var object = canvas.getActiveObject().toObject();
      dispatch(copySelectedToAll(object));
    } else {
      openNotificationWithIcon("error", "Please select an object");
    }
  };

  // function handleChange(value) {
  //   console.log(`selected ${value}`);
  // }

  const handleMenuClick = (e) => {
    if (e.keyPath.includes("BgColor") || e.key === "bgcolor") {
      setIsDropDownVisible(true);
    } else setIsDropDownVisible(false);
  };

  const pageBackgroundMenu = () => {
    return (
      <Menu
        onClick={handleMenuClick}
        items={[
          {
            key: "BgColor",
            label: "Background Color",
            children: [
              {
                key: "bgcolor",
                label: isBgColorPickerOpen ? (
                  <SketchPicker
                    color={pageColor}
                    onChange={(color) => {
                      setIsDropDownVisible(true);
                      setPageColor(color.hex);
                      changePageBgColorOnChange(canvas, color);
                    }}
                    onChangeComplete={(color) => {
                      setIsDropDownVisible(true);
                      setPageColor(color.hex);
                      changePageBgColorOnChangeComplete(canvas, color);
                    }}
                  />
                ) : null,
              },
            ],
          },
          {
            key: "BgImage",
            label: (
              <div onClick={handleBgImgUploadBtnClick}>
                <input
                  type="file"
                  accept="image/"
                  className="hidden"
                  ref={bgImgUploadRef}
                  onChange={(e) => pageBgImage(e, canvas)}
                />
                Background Image
              </div>
            ),
          },
        ]}
      />
    );
  };
  const handleVisibleChange = (flag) => {
    setIsDropDownVisible(flag);
  };
  return (
    <div className="w-auto h-auto bg-white py-2 px-4 rounded-full flex row items-center justify-center">
      <Tooltip title="Add Text" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-blue-200 flex items-center justify-center text-xs px-3 uppercase mx-1 cursor-pointer hover:bg-blue-400"
          onClick={() => {
            addText(canvas);
          }}
        >
          {" "}
          <BiText />{" "}
        </div>
      </Tooltip>
      <Tooltip title="Insert image" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-blue-200 flex items-center justify-center text-xs px-3 uppercase mx-1 cursor-pointer hover:bg-blue-400"
          onClick={handleImgUploadBtnClick}
        >
          <input
            type="file"
            accept="image/"
            className="hidden"
            ref={imgUploadRef}
            onChange={(e) => addImage(e, canvas)}
          />
          <BsFillImageFill />
        </div>
      </Tooltip>
      <Tooltip title="Fonts" placement="bottom" arrowPointAtCenter>
        <div className="mx-1">
          <Select
            defaultValue={currentFont || fonts[7]}
            style={{ width: 120, borderRadius: "10px" }}
            onChange={(e) => {
              setCurrentFont(handleFontChange(e, canvas));
            }}
            className="mx-1"
          >
            {fonts.map((font, index) => (
              <Option value={font} key={index}>
                {font}
              </Option>
            ))}
          </Select>
        </div>
      </Tooltip>
      <Tooltip title="Font size" placement="bottom" arrowPointAtCenter>
        <div className="mx-1">
          <InputNumber
            defaultValue={currentFontSize}
            onChange={(e) => {
              setCurrentFontSize(handleFontSizeChange(e, canvas));
            }}
          />
        </div>
      </Tooltip>

      <div className="mx-1">
        <Radio.Group className="justify-center items-center mx-1">
          <Tooltip title="Align left" placement="bottom" arrowPointAtCenter>
            <Radio.Button value="left">
              <div
                className="w-full h-full flex items-center justify-center mx-1"
                onClick={(e) => {
                  e.preventDefault();
                  alignLeft(canvas);
                }}
              >
                <AiOutlineAlignLeft />
              </div>
            </Radio.Button>
          </Tooltip>
          <Tooltip title="Align center" placement="bottom" arrowPointAtCenter>
            <Radio.Button value="center">
              <div
                className="w-full h-full flex items-center justify-center mx-1"
                onClick={(e) => {
                  e.preventDefault();
                  alignCenter(canvas);
                }}
              >
                <AiOutlineAlignCenter />
              </div>
            </Radio.Button>
          </Tooltip>
          <Tooltip title="Align right" placement="bottom" arrowPointAtCenter>
            <Radio.Button value="right">
              <div
                className="w-full h-full flex items-center justify-center mx-1"
                onClick={(e) => {
                  e.preventDefault();
                  alignRight(canvas);
                }}
              >
                <AiOutlineAlignRight />
              </div>
            </Radio.Button>
          </Tooltip>
        </Radio.Group>
      </div>

      <div className="relative">
        <Tooltip
          title="Font background color"
          placement="bottom"
          arrowPointAtCenter
        >
          <div
            className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
            onClick={() => {
              dispatch(setOpenBgColorPicker(!openBgColorPicker));
            }}
          >
            {" "}
            <AiFillHighlight />{" "}
          </div>
        </Tooltip>
        {openBgColorPicker ? (
          <div className="absolute top-10 left-0 z-50">
            {" "}
            <SketchPicker
              color={currentFontBgColor}
              onChange={(color) => {
                handleFontBgColor(color, canvas);
                setCurrentFontBgColor(color.hex);
              }}
              onChangeComplete={(color) => {
                setCurrentFontBgColor(color.hex);
              }}
            />
          </div>
        ) : (
          ""
        )}
      </div>

      <div className="relative">
        <Tooltip title="Fill" placement="bottom" arrowPointAtCenter>
          <div
            className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
            onClick={() => {
              dispatch(setOpenColorPicker(!openColorPicker));
            }}
          >
            {" "}
            <IoColorFill />{" "}
          </div>
        </Tooltip>
        {openColorPicker ? (
          <div className="absolute top-10 left-0 z-50">
            {" "}
            <SketchPicker
              color={currentFontColor}
              onChange={(color) => {
                handleFontColor(color, canvas);
                setCurrentFontColor(color.hex);
              }}
              onChangeComplete={(color) => {
                setCurrentFontColor(color.hex);
              }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <Tooltip title="Font Style" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={() => {
            // if (currentFontStyle < 2) {
            //   currentFontStyle++;
            // }else{
            //   currentFontStyle = 0;
            // }

            // setCurrentFontStyle(handleFontStyleChange(currentFontStyle, canvas));
            handleFontStyleChange(
              currentFontStyle,
              setCurrentFontStyle,
              canvas
            );
          }}
        >
          {currentFontStyle === 0 ? <RiText /> : ""}
          {currentFontStyle === 1 ? <RiBold /> : ""}
          {currentFontStyle === 2 ? <RiItalic /> : ""}
        </div>
      </Tooltip>
      {/* TODO:   */}
      <div className="relative mx-1 cursor-pointer z-30">
        <Tooltip title="Pencil" placement="bottom" arrowPointAtCenter>
          <div
            className="relative p-2 rounded-full bg-blue-200 flex items-center justify-center hover:bg-blue-400"
            onClick={() => dispatch(setPencilBoxOpen(!pencilBoxOpen))}
          >
            <RiPencilFill />
          </div>
        </Tooltip>
        {pencilBoxOpen && (
          <div className="absolute w-[600px] h-auto bg-white p-2 z-90 mt-3 rounded-md drop-shadow-md flex flex-row">
            <div className="w-1/2 p-3 flex flex-col justify-between">
              <div>
                <Divider>Free drawing</Divider>
              </div>
              <div className="flex flex-row items-center justify-start">
                <span className="uppercase text-xs">Mode</span>
                <div className="ml-8">
                  <Select
                    defaultValue={defaultMode}
                    style={{ width: 190 }}
                    onChange={(e) => {
                      dispatch(setIsDrawingMode(true));
                      handleModeChange(e, setDefaultMode, canvas);
                    }}
                  >
                    <Option value="pencil">Pencil</Option>
                    <Option value="circle">Circle</Option>
                    <Option value="spray">Spray</Option>
                  </Select>
                </div>
              </div>
              <div className="mt-5 flex flex-row">
                <div>
                  <span className="uppercase text-xs">Line Width</span>
                </div>
                <div className="w-full ml-2">
                  <Slider
                    min={0}
                    max={100}
                    onChange={(value) =>
                      lineWidthChange(value, setLinewidthValue, canvas)
                    }
                    value={
                      typeof linewidthValue === "number" ? linewidthValue : 0
                    }
                    step={1}
                  />
                </div>
              </div>
              <div className="flex mt-3 flex-row items-center justify-between">
                <span className="uppercase text-xs">Line Color</span>
                <div
                  className="relative w-[100px] bg-slate-100 py-1 px-3 cursor-pointer flex justify-between items-center ml-3 rounded-md"
                  onClick={() =>
                    dispatch(setLineColorBoxOpen(!lineColorBoxOpen))
                  }
                >
                  <div
                    className=" w-[50px] h-[50px] rounded-md"
                    style={{ backgroundColor: lineColor }}
                  >
                    {lineColorBoxOpen && (
                      <div className="absolute w-auto h-auto bg-white top-12 left-0 mt-3 rounded-md z-90 drop-shadow-lg p-2">
                        <div className="flex row">
                          <div className="z-90 my-5 mx-5 flex flex-col justify-center items-center ">
                            <div className="mb-3 bg-blue-500 text-white w-fit px-2 rounded-full">
                              Choose Line Color
                            </div>
                            <SketchPicker
                              color={lineColor}
                              onChange={(color) => {
                                handleLineColorChange(color, canvas);
                                setLineColor(color.hex);
                              }}
                              onChangeComplete={(color) => {
                                setLineColor(color.hex);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    {lineColorBoxOpen === true ? (
                      <AiFillCaretUp
                        style={{ display: "inline", marginLeft: "10px" }}
                      />
                    ) : (
                      <AiFillCaretDown
                        style={{ display: "inline", marginLeft: "10px" }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="border"></div>
            <div className="w-1/2 p-3">
              <div>
                <Divider>Pencil Shadow</Divider>
              </div>
              <div className="">
                <div className="mt-5 flex flex-row">
                  <div>
                    <span className="uppercase text-xs">Shadow Width</span>
                  </div>
                  <div className="w-full ml-2">
                    <Slider
                      min={0}
                      max={50}
                      onChange={(value) =>
                        shadowWidthChange(value, setShadowWidthValue, canvas)
                      }
                      value={
                        typeof shadowWidthValue === "number"
                          ? shadowWidthValue
                          : 0
                      }
                      step={1}
                    />
                  </div>
                </div>
                <div className="mt-5 flex flex-row">
                  <div>
                    <span className="uppercase text-xs">Shadow Offset</span>
                  </div>
                  <div className="w-full ml-2">
                    <Slider
                      min={0}
                      max={50}
                      onChange={(value) =>
                        shadowOffsetChange(value, setShadowOffsetValue, canvas)
                      }
                      value={
                        typeof shadowOffsetValue === "number"
                          ? shadowOffsetValue
                          : 0
                      }
                      step={1}
                    />
                  </div>
                </div>
                <div className="flex mt-3 flex-row items-center justify-between">
                  <span className="uppercase text-xs">Shadow Color</span>
                  <div
                    className="relative w-[100px] bg-slate-100 py-1 px-3 cursor-pointer flex justify-between items-center ml-3 rounded-md"
                    onClick={() =>
                      dispatch(setShadowColorBoxOpen(!shadowColorBoxOpen))
                    }
                  >
                    <div
                      className=" w-[50px] h-[50px] rounded-md"
                      style={{ backgroundColor: shadowColor }}
                    >
                      {shadowColorBoxOpen && (
                        <div className="absolute w-auto h-auto bg-white top-12 left-0 mt-3 rounded-md z-90 drop-shadow-lg p-2">
                          <div className="flex row">
                            <div className="z-90 my-5 mx-5 flex flex-col justify-center items-center ">
                              <div className="mb-3 bg-blue-500 text-white w-fit px-2 rounded-full">
                                Choose Shadow Color
                              </div>
                              <SketchPicker
                                color={shadowColor}
                                onChange={(color) => {
                                  handleShadowColorChange(color, canvas);
                                  setShadowColor(color.hex);
                                }}
                                onChangeComplete={(color) => {
                                  setShadowColor(color.hex);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div>
                      {shadowColorBoxOpen === true ? (
                        <AiFillCaretUp
                          style={{ display: "inline", marginLeft: "10px" }}
                        />
                      ) : (
                        <AiFillCaretDown
                          style={{ display: "inline", marginLeft: "10px" }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <Tooltip title="Font spacing" placement="bottom" arrowPointAtCenter>
        <div className="relative mx-1 cursor-pointer">
          <div
            className="relative p-2 rounded-full bg-blue-200 flex items-center justify-center hover:bg-blue-400"
            onClick={() => dispatch(setSpaceBoxOpen(!spaceBoxOpen))}
          >
            <CgFormatLineHeight />
          </div>
          {spaceBoxOpen ? (
            <div className="absolute top-10 left-0 w-[200px] z-50 bg-white p-3 rounded-lg">
              <span className="uppercase text-xs">Line Height</span>
              <Slider
                min={0.4}
                max={1.8}
                onChange={(value) =>
                  sliddervaluechange(value, setInputValue, canvas)
                }
                value={typeof inputValue === "number" ? inputValue : 0}
                step={0.01}
              />
              <span className="uppercase text-xs">Letter Spacing</span>
              <Slider
                min={-0.15}
                max={1}
                onChange={(value) =>
                  sliddervaluechange2(value, setInputValue2, canvas)
                }
                value={typeof inputValue2 === "number" ? inputValue2 : 0.5}
                step={0.01}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </Tooltip>
      <div className="relative z-30">
        <Tooltip title="Stroke" placement="bottom" arrowPointAtCenter>
          <div
            className="p-2 rounded-full bg-blue-200 flex items-center justify-center text-xs px-3 uppercase mx-1 cursor-pointer hover:bg-blue-400"
            onClick={() => dispatch(setStrokeBoxOpen(!strokeBoxOpen))}
          >
            Stroke
          </div>
        </Tooltip>
        {strokeBoxOpen && (
          <div className="absolute left-0 top-10 rounded-md p-2 z-90 drop-shadow-md bg-white">
            <div className="flex row">
              <Select
                defaultValue="None"
                style={{ width: 120 }}
                onChange={(e) => handleStrokeStyleChange(e, canvas)}
              >
                <Option value="none">None</Option>
                <Option value="normal">Normal</Option>
                <Option value="dotted">Dotted</Option>
              </Select>
              <div className="w-5"></div>
              <InputNumber
                min={0}
                defaultValue={0}
                onChange={(e) => addStroke(canvas, e)}
              />
            </div>
            <div className="z-90 mt-5 flex justify-center">
              {" "}
              <SketchPicker
                color={currentStrokeColor}
                onChange={(color) => {
                  handleStrokeColor(color, canvas);
                  setCurrentStrokeColor(color.hex);
                }}
                onChangeComplete={(color) => {
                  setCurrentStrokeColor(color.hex);
                }}
              />
            </div>
          </div>
        )}
      </div>
      <div className="relative z-30">
        <Tooltip title="Gradient fill" placement="bottom" arrowPointAtCenter>
          <div
            className="p-2 rounded-full bg-blue-200 flex items-center justify-center text-xs px-3 uppercase mx-1 cursor-pointer hover:bg-blue-400"
            onClick={() => dispatch(setGradientBoxOpen(!gradientBoxOpen))}
          >
            <MdGradient className="text-xl" />
          </div>
        </Tooltip>
        {gradientBoxOpen && (
          <div className="absolute left-0 top-10 rounded-md z-90 drop-shadow-md bg-white p-5 w-[400px]">
            <div className="w-full relative z-30">
              <Divider>Custom Gradient</Divider>
              <div className="flex row justify-evenly items-center">
                <div
                  className="w-[30%] bg-slate-100 py-1 px-3 cursor-pointer flex justify-between items-center ml-3 rounded-md"
                  onClick={() =>
                    dispatch(setCustomGradientBoxOpen(!customGradientBoxOpen))
                  }
                >
                  <div
                    className="relative w-[50px] h-[50px] rounded-md"
                    style={{ backgroundColor: customGradientBoxColor }}
                  ></div>
                  {customGradientBoxOpen === true ? (
                    <AiFillCaretUp
                      style={{ display: "inline", marginLeft: "10px" }}
                    />
                  ) : (
                    <AiFillCaretDown
                      style={{ display: "inline", marginLeft: "10px" }}
                    />
                  )}
                  {customGradientBoxOpen && (
                    <div className="absolute w-auto h-auto bg-white top-24 mt-3 rounded-md z-90 drop-shadow-lg p-2">
                      <div className="flex row">
                        <div className="z-90 my-5 mx-5 flex flex-col justify-center items-center ">
                          <div className="mb-3 bg-blue-500 text-white w-fit px-2 rounded-full">
                            Choose Color 1
                          </div>
                          <SketchPicker
                            color={customGradientBoxColor}
                            onChange={(color) => {
                              handleCustomGradientBoxColor(color, canvas);
                              setCustomGradientBoxColor(color.hex);
                            }}
                            onChangeComplete={(color) => {
                              setCustomGradientBoxColor(color.hex);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="w-[30%] bg-slate-100 py-1 px-3 cursor-pointer flex justify-between items-center ml-3 rounded-md"
                  onClick={() =>
                    dispatch(setCustom2GradientBoxOpen(!custom2GradientBoxOpen))
                  }
                >
                  <div
                    className="relative w-[50px] h-[50px] rounded-md"
                    style={{ backgroundColor: custom2GradientBoxColor }}
                  ></div>
                  {custom2GradientBoxOpen === true ? (
                    <AiFillCaretUp
                      style={{ display: "inline", marginLeft: "10px" }}
                    />
                  ) : (
                    <AiFillCaretDown
                      style={{ display: "inline", marginLeft: "10px" }}
                    />
                  )}
                  {custom2GradientBoxOpen && (
                    <div className="absolute w-auto h-auto bg-white top-24 mt-3 rounded-md z-90 drop-shadow-lg p-2">
                      <div className="flex row">
                        <div className="z-90 my-5 mx-5 flex flex-col justify-center items-center ">
                          <div className="mb-3 bg-blue-500 text-white w-fit px-2 rounded-full">
                            Choose Color 2
                          </div>
                          <SketchPicker
                            color={custom2GradientBoxColor}
                            onChange={(color) => {
                              handleCustom2GradientBoxColor(color, canvas);
                              setCustom2GradientBoxColor(color.hex);
                            }}
                            onChangeComplete={(color) => {
                              handleCustom2GradientBoxColor(color, canvas);
                              setCustom2GradientBoxColor(color.hex);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Divider>Gradient Pallete</Divider>
            <div className="z-90 my-5 mx-5">
              <div
                style={{ maxHeight: "300px", overflowY: "scroll", zIndex: 0 }}
              >
                <div className="grid grid-cols-3 gap-4">
                  {PalleteColor.map((index, i) => {
                    return (
                      <div
                        key={i}
                        onClick={() =>
                          handleGradientPallete(i, PalleteColor, canvas)
                        }
                        className="w-full cursor-pointer h-[50px] rounded-md transition ease-in-out  hover:shadow-xl"
                        style={{
                          background: `linear-gradient(to right,${index[0]},${index[1]})`,
                        }}
                      ></div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="relative z-30">
        <Tooltip
          title="Drop Shadow"
          placement="bottom"
          arrowPointAtCenter
          onClick={() => dispatch(setShadowBoxOpen(!shadowBoxOpen))}
        >
          <div className="p-2 rounded-full bg-blue-200 flex items-center justify-center text-xs px-3 uppercase mx-1 cursor-pointer hover:bg-blue-400">
            shadow
          </div>
        </Tooltip>
        {shadowBoxOpen && (
          <div className="absolute left-0 top-10 rounded-md p-2 z-90 drop-shadow-md bg-white flex row">
            <div className="grid grid-cols-1 gap-2 w-[200px]">
              <div className="mt-5 mx-3">
                <span className="uppercase text-xs">X-axis</span>
                <Slider
                  min={-100}
                  max={100}
                  onChange={(value) => xAxisChange(value, setXAxis, canvas)}
                  value={typeof xAxis === "number" ? xAxis : 0}
                  step={0.01}
                />
              </div>
              <div className="mx-3">
                <span className="uppercase text-xs">Y-axis</span>
                <Slider
                  min={-100}
                  max={100}
                  onChange={(value) => yAxisChange(value, setYAxis, canvas)}
                  value={typeof yAxis === "number" ? yAxis : 0}
                  step={0.1}
                />
              </div>
              <div className="mx-3">
                <span className="uppercase text-xs">Spread</span>
                <Slider
                  min={0}
                  max={100}
                  onChange={(value) => blurChange(value, setBlur, canvas)}
                  value={typeof blur === "number" ? blur : 0}
                  step={0.01}
                />
              </div>
            </div>
            <div className="z-90 my-5 mx-5 flex justify-center">
              <SketchPicker
                color={currentShadowColor}
                onChange={(color) => {
                  handleShadowColor(color, canvas);
                  setCurrentShadowColor(color.hex);
                }}
                onChangeComplete={(color) => {
                  setCurrentShadowColor(color.hex);
                }}
              />
            </div>
          </div>
        )}
      </div>
      <Tooltip
        title="Duplicate to all pages."
        placement="bottom"
        arrowPointAtCenter
      >
        <div
          className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={(e) => {
            e.preventDefault();
            copyToAllPages(canvas);
          }}
        >
          <GrMultiple />
        </div>
      </Tooltip>
      <div className="relative mx-1 cursor-pointer">
        <Tooltip title="Opacity" placement="bottom" arrowPointAtCenter>
          <div
            className="relative p-2 rounded-full bg-blue-200 flex items-center justify-center hover:bg-blue-400"
            onClick={() => {
              dispatch(setOpacityBoxOpen(!openOpacityBox));
            }}
          >
            <MdOpacity />
          </div>
        </Tooltip>
        {openOpacityBox ? (
          <div className="absolute top-10 left-0 w-[200px] z-50 bg-white p-3 rounded-lg">
            <Slider
              min={0}
              max={1}
              onChange={(value) =>
                changeOpacity(canvas, setOpacityValue, value)
              }
              value={typeof opacityValue === "number" ? opacityValue : 0}
              step={0.01}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <Tooltip title="Bring Forward" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={(e) => {
            e.preventDefault();
            objectBringForward(canvas);
          }}
        >
          <RiBringToFront />
        </div>
      </Tooltip>
      <Tooltip title="Send Back" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={(e) => {
            e.preventDefault();
            objectSendBackward(canvas);
          }}
        >
          <RiSendToBack />
        </div>
      </Tooltip>
      <Tooltip
        title="Background"
        placement="bottom"
        arrowPointAtCenter
        className="flex"
      >
        <Dropdown
          overlay={pageBackgroundMenu}
          trigger={["click"]}
          visible={isDropDownVisible}
          onVisibleChange={handleVisibleChange}
        >
          <div className="p-2 rounded-full bg-blue-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400">
            <FaPaintRoller />
          </div>
        </Dropdown>
      </Tooltip>
      <Tooltip title="Undo" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-red-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={() => {
            canvas.undo();
          }}
        >
          <ImUndo />
        </div>
      </Tooltip>
      <Tooltip title="Redo" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-red-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={() => {
            canvas.redo();
          }}
        >
          <ImRedo />
        </div>
      </Tooltip>
      <Tooltip title="Remove" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-red-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={(e) => {
            e.preventDefault();
            deleteObject(canvas);
          }}
        >
          <MdDelete />
        </div>
      </Tooltip>
      <Tooltip title="Clear page" placement="bottom" arrowPointAtCenter>
        <div
          className="p-2 rounded-full bg-red-200 flex items-center justify-center mx-1 cursor-pointer hover:bg-blue-400"
          onClick={(e) => {
            e.preventDefault();
            setClearCanvasModel(true);
          }}
        >
          <FaEraser />
        </div>
      </Tooltip>
      <Modal
        title="Warning"
        visible={clearCanvasModel}
        onOk={(e) => {
          e.preventDefault();
          clearCanvas(canvas);
          setClearCanvasModel(false);
        }}
        onCancel={(e) => {
          e.preventDefault();
          setClearCanvasModel(false);
        }}
      >
        Are you sure to remove all objects?
      </Modal>
    </div>
  );
};

export default PropertyBar;
